// extracted by mini-css-extract-plugin
module.exports = {"root":"qqc5Q","bannersWrapper":"_2ry2q","banner":"_1pjfh","bannerDetail":"_1GmCt","title":"_11SlK","cta":"qKAoe","image":"_3TbEt"};